import { Drawer, Box } from '@mui/material'
import { type ReactNode, useEffect, useRef } from 'react'

interface DrawerStateProps {
  onClose: () => void
  children: ReactNode
  maxWidth?: string
}

const getDrawerMaxWidth = (detailsOpen: boolean, chatOpen: boolean): string => {
  if (detailsOpen && chatOpen) return '95%'
  if (detailsOpen || chatOpen) return '80%'
  return '50%'
}

export const DrawerState = ({
  onClose,
  children,
  maxWidth = getDrawerMaxWidth(true, false),
}: DrawerStateProps) => {
  const drawerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleThemeChange = () => {
      if (drawerRef.current) {
        drawerRef.current.style.display = 'none'
        // Force reflow by reading offsetHeight
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _ = drawerRef.current.offsetHeight
        drawerRef.current.style.display = 'flex'
      }
    }

    const observer = new MutationObserver(handleThemeChange)
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    })

    return () => observer.disconnect()
  }, [])

  return (
    <Drawer
      open
      onClose={onClose}
      anchor="bottom"
      ModalProps={{
        disableScrollLock: true,
        keepMounted: false,
      }}
      slotProps={{
        paper: {
          ref: drawerRef,
          sx: {
            width: maxWidth,
            maxWidth,
            left: '50% !important',
            transform: 'translateX(-50%) !important',
            position: 'fixed',
            bottom: 0,
            zIndex: 1300,
          },
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          height: 'calc(100vh - 24px)',
          bgcolor: 'background.paper',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {children}
      </Box>
    </Drawer>
  )
}
